import { Component, OnInit } from '@angular/core';
import { GetTokenBindingModel } from 'src/app/api/models/base.model';
import { IsValidPasswordResetKeyBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  newPassword: string;
  confirmNewPassword: string;
  resetKey: string;
  email: string;
  customerId: string;

  ngOnInit(): void {
    this.app.pageTitle = 'Reset your password';
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();

      this.customerId = this.app.storageService.getItem(AppConstants.CustomerId);
      if (this.app.stringService.isEmpty(this.customerId)) {
        this.app.router.navigate([AppConstants.RouteInvalid]);
        return;
      }

      this.email = this.app.storageService.getItem(AppConstants.CustomerEmail);
      if (this.app.stringService.isEmpty(this.email)) {
        this.app.router.navigate([AppConstants.RouteInvalid]);
        return;
      }

      this.scrollTo();

    });
    this.start();
  }

  backToLogin(): void {
    this.app.router.navigate([AppConstants.RouteLogin]);
  }

  validateResetKey(): void {
    this.app.spinner.show();
    const m = new IsValidPasswordResetKeyBindingModel();
    m.resetKey = this.resetKey;
    m.customerId = this.customerId;
    this.app.webBookingService.IsValidPasswordResetKey(m)
      .subscribe(
        data => {
          if (data.valid) {
            this.email = data.email;
            this.app.spinner.hide();
            this.newPassword = '';
            this.confirmNewPassword = '';
          }
          else {
            this.app.spinner.hide();
            this.showErrorMessage('Failed to validate reset key');
            this.app.router.navigate([AppConstants.RouteLogin]);
          }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
          this.app.router.navigate([AppConstants.RouteLogin]);
        });
  }

  submit(): void {
    const model = {
      customerId: this.customerId,
      resetKey: this.resetKey,
      newPassword: this.newPassword,
      confirmNewPassword: this.confirmNewPassword
    };
    this.app.webBookingService.ResetPassword(model)
      .subscribe(
        data => {
          this.showInfoMessage('Password reset successful.');
          this.app.storageService.removeItem(AppConstants.CustomerEmail);
          this.app.storageService.removeItem(AppConstants.CustomerId);
          setTimeout(() => {
            this.getToken(this.email, this.newPassword);
          }, 1000);
        },
        error => {
          this.showErrorMessage(error);
        });
  }

  resend(): void {
    this.app.spinner.show();
    const model = { email: this.email, resetPageUrl: this.app.configService.config.appUrl + 'reset-password/' };
    this.app.webBookingService.SendPasswordResetKeyLinkToEmail(model)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, this.email);
          this.showSuccessMessage('Reset password code has been sent to your email address.');
        },
        error => {
          this.showErrorMessage(error);
          this.app.spinner.hide();
        });
  }

  getToken(email: string, password: string): void {
    const model: GetTokenBindingModel =
    {
      username: email,
      email,
      password,
      grand_type: 'password'
    };

    this.app.spinner.show();
    this.app.webBookingService.GetToken(model)
      .subscribe(
        data => {
          data.created_date = this.app.dateService.formatDateTime(new Date());
          this.app.storageService.setItem(AppConstants.Token, JSON.stringify(data));
          this.getProfile();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.checkCustomerData();
          this.redirectToNextPage();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

}
